<template>
  <td
    class="price-cell"
    :class="{'has-text-info': bomItem.highlight}"
    @dblclick.stop="open"
  >
    <label v-if="!bomItem.orderable" />
    <label v-else-if="priceAmount === 0">{{ $t('noPrice') }}</label>
    <label v-else-if="price">{{ price }}</label>
  </td>
</template>

<script>
export default {
  name: 'BomCellPrice',
  props: {
    bomItem: {
      type: Object,
      required: true
    },
    column: {
      type: Object,
      required: true
    },
    hideRetailPrice: {
      type: Boolean,
      default: false
    },
    hideDiscountPrice: {
      type: Boolean,
      default: false
    },
    hideWholeSalePrice: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    price () {
      if (this.column.property === 'retail' && !this.hideRetailPrice) {
        return this.bomItem.retailPrice
      } else if (this.column.property === 'wholesale' && !this.hideWholeSalePrice) {
        return this.bomItem.wholesalePrice
      } else if (this.column.property === 'discounted' && !this.hideDiscountPrice) {
        return this.bomItem.discountPrice
      }
      return ''
    },
    priceAmount () {
      if (this.column.property === 'retail' && !this.hideRetailPrice) {
        return this.bomItem.retailAmount
      } else if (this.column.property === 'wholesale' && !this.hideWholeSalePrice) {
        return this.bomItem.wholesaleAmount
      } else if (this.column.property === 'discounted' && !this.hideDiscountPrice) {
        return this.bomItem.discountAmount
      }
      return -1
    }
  },
  methods: {
    open () {
      this.$emit('open', {
        content: this.bomItem,
        route: ''
      })
    }
  }
}
</script>

<style scoped>
.price {
  text-align: center;
}
.table tr.is-selected td {
  color: currentColor !important;
}
</style>
